//import { importExpr } from '@angular/compiler/src/output/output_ast';
import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
// import { NotificationsService } from 'angular2-notifications';
// import { ToastrService } from 'ngx-toastr';
import { BaseCommonComponent, BaseDataService, ModalService, NotificationService, UserService } from 'yt-ng-framework';

@Component({
  selector: 'yt-ponovi',
  templateUrl: './ponovi.component.html'
})
export class PonoviComponent extends BaseCommonComponent implements OnInit{

submitted = false;
@Input() Parameters;
// naslov = "";
// nazivLabele1 = "";
// nazivLabele2 = "";
// labela1Visibility : boolean = true;
// labela2Visibility : boolean = true;

constructor(
  protected activateRoute: ActivatedRoute,
  protected activeModal: NgbActiveModal,
  protected baseDataService: BaseDataService,
  // protected notificationService: NotificationsService,
  protected toastrService: NotificationService,
  protected translateService: TranslateService,
  protected userService: UserService,
  protected modalService: ModalService,
){
  super(activateRoute,userService,baseDataService,translateService,modalService,toastrService);

}
 vrstaDokumenta: string;


ngOnInit() {

  let date = new Date();
  this.vrstaDokumenta = this.Parameters[4].Value;


  this.baseFormGroup = new FormGroup({
    DatumDokumenta: new FormControl(new NgbDate(date.getFullYear(), date.getMonth()+1,date.getDate())), 
    PeriodOd: new FormControl(new NgbDate(date.getFullYear(), date.getMonth()+1,date.getDate())), 
    PeriodDo: new FormControl(new NgbDate(date.getFullYear(), date.getMonth() + 1, date.getDate()))
    , copy_korekcija: new FormControl(false)
    , copy_objekat: new FormControl(false)
    , copy_napomena: new FormControl(false)
  });

  let isAcceptParam = this.Parameters.find(p => p != null && p.Name === 'accept');
    let isAccept = false;

    if (isAcceptParam) {
      isAccept = isAcceptParam.Value === true; 
    }

  this.addValidatorToFc('DatumDokumenta', Validators.required, 'required', 'FAKDOKUMENT.DATDOK.VALIDATION.REQUIRED');
  this.baseFormGroup.setValidators(checkDatumeSaDatumomDokumenta('PeriodOd', 'PeriodDo', this));

    //this.addValidatorToFc('PeriodOd', Validators.required, 'required', 'FAKDOKUMENT.DATUMPROMETAOD.VALIDATION.REQUIRED');
    //this.addValidatorToFc('PeriodDo', Validators.required, 'required', 'FAKDOKUMENT.DATUMPROMETADO.VALIDATION.REQUIRED');
  
}


Close(){
  this.activeModal.close();
}

Ok(){
  this.submitted = true;

  if (this.vrstaDokumenta == 'faktura' || this.vrstaDokumenta == 'fak-avansni' || this.vrstaDokumenta == 'fak-ponuda' || this.vrstaDokumenta == 'fak-predracun' || this.vrstaDokumenta == 'knjizno-odobrenje' || this.vrstaDokumenta == 'knjizno-zaduzenje' || this.vrstaDokumenta == 'faktura-izvozna') {

  if (this.baseFormGroup.valid) {
    let datumDok = this.baseFormGroup.get('DatumDokumenta').value;
    let periodOd = this.baseFormGroup.get('PeriodOd').value;
    let periodDo = this.baseFormGroup.get('PeriodDo').value;
    let copy_korekcija = this.baseFormGroup.get('copy_korekcija').value;
    let copy_objekat = this.baseFormGroup.get('copy_objekat').value;
    let copy_napomena = this.baseFormGroup.get('copy_napomena').value;

    //this.activeModal.close(datumDok + ";" + periodOd + ";" +periodDo);
    this.activeModal.close({
      datumDok: this.baseFormGroup.get('DatumDokumenta').value,
      periodOd: this.baseFormGroup.get('PeriodOd').value,
      periodDo: this.baseFormGroup.get('PeriodDo').value
      , copy_korekcija: this.baseFormGroup.get('copy_korekcija').value
      , copy_objekat: this.baseFormGroup.get('copy_objekat').value
      , copy_napomena: this.baseFormGroup.get('copy_napomena').value
  });
  }
    }
    else {
      if (this.baseFormGroup.valid) {
        let datumDok = this.baseFormGroup.get('DatumDokumenta').value;

        this.activeModal.close({
          datumDok: this.baseFormGroup.get('DatumDokumenta').value,
        });
      }
  }
  }
}
  function checkDatumeSaDatumomDokumenta(datumPrometaOdKey: string, datumPrometaDoKey: string, mainThis: any) {
    return (group: FormGroup): { [key: string]: any } => {
      if (mainThis && !(mainThis.vrstaDokumenta != 'fak-ponuda' && mainThis.vrstaDokumenta != 'fak-predracun' && mainThis.vrstaDokumenta != 'fak-avansni'))
        return;

      let datum = mainThis.baseFormGroup.get("DatumDokumenta").value;
      let _datum: Date = datum != null ? new Date(datum["year"], datum["month"] - 1, datum["day"]) : null;
      let datumPrometaOd = group.controls[datumPrometaOdKey].value;
      let _datumPrometaOd: Date = datumPrometaOd != null ? new Date(datumPrometaOd["year"], datumPrometaOd["month"] - 1, datumPrometaOd["day"]) : null;
      let datumPrometaDo = group.controls[datumPrometaDoKey].value;
      let _datumPrometaDo: Date = datumPrometaDo != null ? new Date(datumPrometaDo["year"], datumPrometaDo["month"] - 1, datumPrometaDo["day"]) : null;

      let genericName: string = null;

      if (mainThis.podvrstaDokumentaGn)
        genericName = mainThis.podvrstaDokumentaGn;

      if ((_datumPrometaOd && _datumPrometaOd > _datum) || (_datumPrometaDo && _datumPrometaDo > _datum)) {
        return {
          checkControlsDatumPrometaOd: { valid: _datumPrometaOd && _datumPrometaOd > _datum ? false : true, message: 'FAKDOKUMENT.DATUMPROMETAOD.VALIDATION.DATUMVECI' },
          checkControlsDatumPrometaDo: { valid: _datumPrometaDo && _datumPrometaDo > _datum ? false : true, message: 'FAKDOKUMENT.DATUMPROMETADO.VALIDATION.DATUMVECI' }
        };
      }



    }

  }
